
import DcoTable from '../../components/dco-table';
import { parseTime } from '@/filters';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import _ from 'lodash';
export default {
  components: {
    DcoTable: DcoTable
  },
  props: {
    dcoDialog: {
      type: Object,
      default: function _default() {}
    },
    type: {
      default: 'vmaker',
      type: String
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    infoData: {
      type: Object,
      default: function _default() {}
    },
    updatePreviewDialog: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      list: [],
      filterplatform: 0,
      filterlanguage: 0
    };
  },

  computed: {
    infoConfig: function infoConfig() {
      return [{
        label: 'DCO Id',
        prop: 'id',
        content: _.get(this.infoData, 'id') || ''
      }, {
        label: '名称',
        prop: 'name',
        content: _.get(this.infoData, 'name') || ''
      }, {
        label: '进度',
        prop: 'progress',
        content: _.get(this.infoData, 'progress') + '\uFF08\u5206\u5B50\u4E3A\u5B8C\u6210\u5236\u4F5C\u4E2A\u6570\uFF0C\u5206\u6BCD\u4E3A\u9700\u8981\u5236\u4F5C\u603B\u4E2A\u6570\uFF09'
      }, {
        label: '状态',
        prop: 'status',
        content: _.get(this.infoData, 'status') || ''
      }, {
        label: '组合个数',
        prop: 'status',
        content: _.get(this.infoData, 'groups') || ''
      }, {
        label: '更新时间',
        prop: 'updated_time',
        content: parseTime(_.get(this.infoData, 'updated_time'), '{y}-{m}-{d} {h}:{i}:{s}') || ''
      }];
    },
    innerInfoConfig: function innerInfoConfig() {
      var tempConfig = [];
      var column = [];
      if (this.type === 'vmaker') ['id', 'name', 'progress', 'updated_time'].map(function (item) {
        column.push(item);
      });
      if (this.type === 'template') ['id', 'name', 'status', 't-progress', 'updated_time'].map(function (item) {
        column.push(item);
      });
      this.infoConfig.map(function (infoColumn) {
        column.map(function (item) {
          if (infoColumn && infoColumn.prop === item) {
            tempConfig.push(infoColumn);
          }
        });
      });
      return tempConfig;
    },
    innerColumnConfig: function innerColumnConfig() {
      if (this.type === 'vmaker') {
        return ['gid', 'resolution', 'action-cell'];
      }
      return ['dco_id', 'gid', 'channel', 'platform', 'traffic_type', 'language', 'action-cell'];
    },
    platformOptions: function platformOptions() {
      var opionts = [];
      if (this.data.length) {
        this.data.forEach(function (item) {
          if (opionts.length === 0 || !opionts.some(function (option) {
            return option.label === item.platform;
          })) {
            opionts.push({
              label: item.platform,
              value: opionts.length
            });
          }
        });
      }
      return opionts;
    },
    languageOptions: function languageOptions() {
      var opionts = [];
      if (this.data.length) {
        this.data.forEach(function (item) {
          if (opionts.length === 0 || !opionts.some(function (option) {
            return option.label === item.language;
          })) {
            opionts.push({
              label: item.language,
              value: opionts.length
            });
          }
        });
      }
      return opionts;
    },
    innerList: function innerList() {
      var _this = this;

      var list = this.data;
      if (this.filterplatform !== '') {
        list = list.filter(function (item) {
          return item.platform === useValueExchangeLabel(_this.filterplatform, _this.platformOptions);
        });
      }
      if (this.filterlanguage !== '') {
        list = list.filter(function (item) {
          return item.language === useValueExchangeLabel(_this.filterlanguage, _this.languageOptions);
        });
      }
      return list;
    }
  },
  methods: {
    showRenderPreview: function showRenderPreview(item) {
      if (this.type === 'vmaker') {
        this.updatePreviewDialog({
          url: item.video_url
        });
      }
      if (this.type === 'template') {
        this.updatePreviewDialog(item);
      }
    }
  }
};